import React, { Component } from 'react'
import ListingPage, { TABLE_ACTIONS } from '../../../containers/ListingPage'
import StoreSelector from '../../../containers/StoreSelector'
import { isExtensionEnabled } from '../../../lib/auth'
import { getMessage } from '../../../lib/translator'
import emptyIcon from '../Orders/Table/no-orders.svg'
import '../Orders/Table/style.css'
import './style.scss'
import {
  ORDER_DETAILS_API_URL,
  ORDER_DETAILS_PAGE_SIZE,
  buildQueryParams,
  normalizeRows,
} from './api/orderDetails'
import PickingDeliveryOrderFilters from './filters/Filters'
import { tabularView } from './table/tabularView'

const emptyState = (props) => ({
  icon: emptyIcon,
  message: getMessage('order.emptyList.message'),
  actions: ({ onAction, apiParams }) => (
    <React.Fragment>
      {isExtensionEnabled('MultiStoreSupport') && (
        <StoreSelector
          value={apiParams.storeId}
          stores={props.stores}
          onChange={(storeId) => {
            onAction(TABLE_ACTIONS.SET_API_PARAMS, {
              storeId,
            })
          }}
        />
      )}
    </React.Fragment>
  ),
})

class ListPage extends Component {
  getSearchParams(formData) {
    let searchParams = ''
    Object.keys(formData)
      .filter(
        (key) => key !== 'filters' && (formData[key] === 0 || formData[key])
      )
      .forEach((key, index) => {
        if (index === 0) {
          searchParams += `?${key}=${formData[key]}`
        } else {
          searchParams += `&${key}=${formData[key]}`
        }
      })
    return searchParams
  }

  render() {
    const { props } = this
    const basePath = props.url || '/operations'

    return (
      <ListingPage
        menu={props.menu}
        className={`orders-page picking-delivery-orders ${
          props.className || 'ops'
        }`}
        title={getMessage('picking.orderDetail.page.title')}
        api={{
          url: ORDER_DETAILS_API_URL,
          params: {
            pageSize: ORDER_DETAILS_PAGE_SIZE,
            ...(props.params || {}),
          },
          transform: normalizeRows,
          updateApiParams: (
            _prevParams,
            _newParams,
            prevStateParams,
            newStateParams
          ) => {
            if (!newStateParams?.storeId) {
              return null
            }
            const storeChanged =
              prevStateParams?.storeId !== newStateParams.storeId
            if (storeChanged) {
              return {
                shouldUpdate: true,
                clearPagination: true,
                params: {
                  storeId: newStateParams.storeId,
                  pageSize: ORDER_DETAILS_PAGE_SIZE,
                },
              }
            }
            return null
          },
        }}
        primaryKey="orderId"
        emptyState={props.emptyState ? props.emptyState() : emptyState(props)}
        filters={{
          component: PickingDeliveryOrderFilters,
          transformFilter: (formData) => buildQueryParams(formData),
          transformSubmit: (formData) => {
            const searchParams = this.getSearchParams(formData)
            if (searchParams !== '' && props.history) {
              props.history.push({ search: searchParams })
            }
            return buildQueryParams(formData)
          },
          forceShow: true,
        }}
        onClear={() => props.history && props.history.push({ search: '' })}
        tableProperties={tabularView(basePath)}
        tableDynamic
        storeDependent
      />
    )
  }
}

export default ListPage
export { emptyState }
